import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {DbServerErrors} from "../../../interceptors/db-server-errors";
import {DbResponse} from "../../../interceptors/db-response";
import {UserManagementService} from "../../../../user-managment/user-management.service";
import {DbValidators} from "../../../validators/DbValidators";
import * as workspaceActions from "../../../../store/actions/workspace.action";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';
import {filter, first} from "rxjs/operators";
import {TypeUtils} from "../../../utils/type-utils";
import * as userActions from "../../../../store/actions/user.action";
import {SwitchWorkspace} from "../../../../store";
import * as websiteActions from "../../../../store/actions/website.action";
import {GlobalEvent} from "../../../services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../../../services/global-event-dispatcher/global-event-dispatcher.service";
import {Router} from "@angular/router";

export interface IWorkspaceDialogInput {
  leaveWorkspace: boolean;
  user?: any;
  workspaceName: any;
  workspaceId?: any;
}

@Component({
    selector: 'db-workspace-dialog',
    templateUrl: './leave-remove-workspace-dialog.component.html',
    styleUrls: ['./leave-remove-workspace-dialog.component.scss'],
    standalone: false
})
export class LeaveRemoveWorkspaceDialogComponent extends DialogComponent<IWorkspaceDialogInput, Boolean> implements OnInit {

  @Input() leaveWorkspace: boolean;
  public loading: boolean = false;
  public serverErrors: DbServerErrors;
  public showPassword: boolean = false;
  public workspace: any;
  @Input() user?: any;
  @Input() workspaceName: any;
  @Input() workspaceId?: any;
  public workspaceForm: FormGroup = new FormGroup({
    password: new FormControl('', [DbValidators.trim, Validators.required]),
    confirm: new FormControl(null, Validators.required)
  });

  constructor(
    private _dialogService: DialogService,
    private _userManagementService: UserManagementService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.leaveWorkspace ? this.workspaceForm.get('confirm').disable() : this.workspaceForm.get('confirm').enable();
  }

  public togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  public remove(): void {

    if (!this.user.status) {
      this._userManagementService.removeInvitation(this.user.id, this.workspaceForm.value.password)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          this.loading = false;
          if (!response.success) {
            this.serverErrors = response.serverErrors;
          }
          else {
            this._store.dispatch(new workspaceActions.LoadWorkspaceAllClients());
            this.result = true;
            this.close();
          }
        });
    } else {
      this._userManagementService.removeUser(this.user.id, this.workspaceForm.value.password)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          this.loading = false;
          if (!response.success) {
            this.serverErrors = response.serverErrors;
          }
          else {
            this._store.dispatch(new workspaceActions.LoadWorkspaceAllClients());
       //     this.switchingWorkspaceToOwner();
            this.result = true;
            this.close();
          }
        });
    }
  }

  public switchingWorkspaceToOwner(): void {
    const switchToWorkspace = {
      ownerWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceRoleId: 1
    };

    this.switchToWorkspace(switchToWorkspace.currentWorkspaceId, switchToWorkspace);
  }

  public switchToWorkspace(workspaceId: number|string, switchToWorkspace?: any): void {
    this._userManagementService.switchWorkspace(workspaceId)
      .pipe(
        filter(response => !!response),
        first()
      )
      .subscribe(response => {
        if (response.success) {
          if ( TypeUtils.isDefined(switchToWorkspace)) {
            this._store.dispatch(new fromStore.SetWorkspaceIdEntities(
              {
                ownerWorkspaceId: +switchToWorkspace.ownerWorkspaceId,
                currentWorkspaceId: +switchToWorkspace.currentWorkspaceId,
                currentWorkspaceRoleId: switchToWorkspace.currentWorkspaceRoleId,
                globalEventDispatcherService: this._globalEventDispatcher
              }
            ));

            this._store.dispatch(new userActions.LoadUser());
            this._store.dispatch(new userActions.LoadUserSubscription());
            this._store.dispatch(new userActions.LoadUserAvailableSubscriptions());
            this._store.dispatch(new SwitchWorkspace({switching: false, workspaceName: '', redirect: true}));
            this._store.dispatch(new websiteActions.ClearWebsites());
            this._store.dispatch(new websiteActions.LoadWebsites());
          }
          else {
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.workspaceSwitch);
          }
          this._router.navigate(['/websites']);

        }
      });
  }


  public leave(): void {
    this._userManagementService.leaveWorkspace(this.workspaceId, this.workspaceForm.value.password)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (!response.success) {
          this.serverErrors = response.serverErrors;
        }
        else {
          this._store.dispatch(new workspaceActions.LoadWorkspaceAllClients());
       //   this.switchingWorkspaceToOwner();
          this.result = true;
          this.close();
        }
      });
  }

  submit(): void {
    if (this.workspaceForm.invalid || this.loading) {
      return;
    }

    this.loading = true;

    this.leaveWorkspace ? this.leave() : this.remove();
  }

  public confirmWPAdminNotifier(event): void {
    if (!event.target.checked) {
      this.workspaceForm.get('confirm').setValue(null);
    }
  }

}
